/* global fetch */

import querystring from 'querystring';
import { config } from '../config';
import { headers, APIResponse, stleaf, fetchAPI, SpanTag } from '../helpers';

export const search = (st: SpanTag, opts): Promise<APIResponse> => {
  const queryString = querystring.stringify(opts);
  const query = `?${queryString}`;
  return fetchAPI(
    stleaf(st, 'ohfie3'),
    `${config.API_URL}/v1/user-tags${query}`,
    {
      method: 'GET',
      credentials: 'include',
      headers,
    },
  );
};
